import { CONTENT_TYPES } from "constants/phase";
import moment from "moment";
import { createSelector } from "reselect";

import { contentImageEntityAdapter, contentImageSlice } from "./slice";

const selectContentImageState = (state) => state[contentImageSlice.name];

export const selectContentImagesDetails = createSelector(selectContentImageState, (contentImageState) =>
  contentImageEntityAdapter.getSelectors().selectAll(contentImageState),
);

export const selectContentImagesCount = createSelector(
  selectContentImageState,
  (contentImageState) => contentImageState.totalItems,
);

export const selectContentImageById = createSelector(
  selectContentImageState,
  (_, props) => {
    return {
      contentId: props.contentId,
      contentType: props.contentType,
      contentImageId: props.contentImageId,
    };
  },
  (contentImageState, { contentId, contentType, contentImageId }) => {
    if (contentType === CONTENT_TYPES.IMAGE || contentImageId) {
      return contentImageEntityAdapter.getSelectors().selectById(contentImageState, contentImageId || contentId);
    }

    return null;
  },
);

export const selectContentImageImageById = createSelector(
  selectContentImageById,
  (contentImage) => contentImage?.image,
);

export const selectContentImageUrlById = createSelector(
  selectContentImageImageById,
  (contentImageImage) => contentImageImage?.imageUrl,
);

export const selectContentImageTitleById = createSelector(
  selectContentImageImageById,
  (contentImageImage) => contentImageImage?.title,
);

export const selectContentImageCreatedAtById = createSelector(
  selectContentImageImageById,
  (contentImageImage) => contentImageImage?.createdAt,
);

export const selectContentImageDisplayCreatedAtById = createSelector(selectContentImageCreatedAtById, (createdAt) =>
  moment(createdAt).format("MMM DD, YYYY HH:mm"),
);

export const selectContentImageContentIdById = createSelector(
  selectContentImageImageById,
  (contentImageImage) => contentImageImage?.contentId,
);

export const selectContentImageCaptureTimeById = createSelector(
  selectContentImageImageById,
  (contentImageImage) => contentImageImage?.captureTime,
);

export const selectContentImageDisplayCaptureTimeById = createSelector(
  selectContentImageCaptureTimeById,
  (captureTime) => {
    if (!captureTime && captureTime !== 0) {
      return "";
    }

    return moment.utc(captureTime * 1000).format("HH:mm:ss");
  },
);

export const selectContentImageGeneration = createSelector(
  selectContentImageById,
  (contentImage) => contentImage?.generation,
);

export const selectContentImageGenerationStatus = createSelector(
  selectContentImageGeneration,
  (generation) => generation?.status,
);

export const selectContentImagesTotalItems = createSelector(
  selectContentImageState,
  (contentImageState) => contentImageState.totalItems,
);
